import gql from 'graphql-tag';

export const QueryPointsBalancesByUserId = gql`
	query QueryPointsBalancesByUserId($userId: ID!, $first: Int) {
		queryPointsBalancesByUserId(userId: $userId, first: $first) {
			items {
				balanceId
				companyId
				createdAt
				currentSpendable
				earned
				isAllTime
				nonSpendable
				periodKey
				pointsCustom
				pointsReferrals
				pointsEngagement
				pointsRecognition
				updatedAt
				spent
				spendable
				userId
			}
		}
	}
`;
